import { useMutation } from "@tanstack/react-query";

import { Products } from "../../../api/products";
import { MutationKey } from "../../../consts/mutation-keys";
import { QueryKey } from "../../../consts/query-keys";
import { useApiError } from "../../../hooks/useApiError";
import { useApiSuccess } from "../../../hooks/useApiSuccess";

export function useProductCreate(successFn: () => void) {
  const { handleSuccess } = useApiSuccess({
    snackbarText: "Product created.",
    invalidate: [[QueryKey.Products]],
    onSuccessFn: successFn,
  });

  const { handleError } = useApiError();

  const mutationFn = (productName: string) =>
    Products.create(undefined, { Name: productName });

  const { mutate: createProduct, isPending } = useMutation({
    mutationKey: [MutationKey.DeleteProduct],
    mutationFn: mutationFn,
    onSuccess: handleSuccess,
    onError: handleError,
    retry: 0,
  });

  return { createProduct, isPending };
}
